import React from 'react';
import { motion } from 'framer-motion';

const StatCard = ({ label, value, subtext, icon: Icon, colorClass }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="glass-card p-6 flex items-center gap-5"
    >
      <div className={`w-12 h-12 rounded-2xl flex items-center justify-center bg-gradient-to-br ${colorClass || 'from-white/10 to-white/5'}`}>
        <Icon className="w-6 h-6 text-white" />
      </div>
      <div>
        <p className="text-sm font-medium text-white/50 uppercase tracking-wider">{label}</p>
        <p className="text-2xl font-bold tracking-tight">{value}</p>
        {subtext && <p className="text-xs text-white/30 mt-1">{subtext}</p>}
      </div>
    </motion.div>
  );
};

export default StatCard;
